import { createSystem, defaultConfig } from "@chakra-ui/react";

// Brand color palette from your CSS custom properties
const brandColors = {
  // Primary color scale
  50: "#e9f6f1", // subtle
  100: "#d3eee4",
  200: "#a7decb",
  300: "#78cdb1",
  400: "#4fba98",
  500: "#2f8f6b", // base
  600: "#26755a", // hover
  700: "#1f5e48", // bold/active
  800: "#1a4d3a",
  900: "#153d2e",
  950: "#0f2d22",
};

// Create the custom theme system
export const customTheme = createSystem(defaultConfig, {
  theme: {
    tokens: {
      colors: {
        // Add your brand colors to the color palette
        primary: {
          50: { value: brandColors[50] },
          100: { value: brandColors[100] },
          200: { value: brandColors[200] },
          300: { value: brandColors[300] },
          400: { value: brandColors[400] },
          500: { value: brandColors[500] },
          600: { value: brandColors[600] },
          700: { value: brandColors[700] },
          800: { value: brandColors[800] },
          900: { value: brandColors[900] },
          950: { value: brandColors[950] },
        },

        // Semantic color tokens with your naming conventions
        "primary-subtle": { value: brandColors[50] },
        "primary-base": { value: brandColors[500] },
        "primary-bold": { value: brandColors[700] },

        // Interactive states
        "primary-hover": { value: brandColors[600] },
        "primary-active": { value: brandColors[700] },

        // On-color text variants
        "on-primary-subtle": { value: "#0f172a" }, // near slate-900 for tints
        "on-primary-base": { value: "#ffffff" },
        "on-primary-bold": { value: "#ffffff" },
      },
      fonts: {
        heading: { value: "'Montserrat', sans-serif" },
        body: { value: "'Montserrat', sans-serif" },
      },
    },
  },
});

export default customTheme;
